import React from 'react';
const FormHtmlRenderer = (props) => {
    const { children, } = props;
    const form_id = props.form.name;
    return (React.createElement("form", { id: form_id, onSubmit: (e) => {
            var _a;
            e.preventDefault();
            (_a = props.formController) === null || _a === void 0 ? void 0 : _a.submitData();
        } }, children));
};
export default FormHtmlRenderer;
//# sourceMappingURL=FormHtmlRenderer.js.map